module.exports = __webpack_public_path__ + "img/inca_ba_list.38d99f2e.jpg";